// extracted by mini-css-extract-plugin
export default {"wrapper":"price-lockup-module__wrapper--b66","cents":"price-lockup-module__cents--Lql"};